// ============================================
// Google Analytics 4 — carga condicional
// ============================================
// Solo se activa si VITE_GA_MEASUREMENT_ID está definido en build time
// (local: .env / producción: build-arg en cloudbuild.yaml).
// SPA: el page_view se envía manualmente en cada cambio de ruta desde App.jsx,
// por eso send_page_view va en false.

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || "";

export function initAnalytics() {
  if (!GA_ID || typeof window === "undefined" || window.gtag) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

export function trackPageview(path) {
  if (!GA_ID || !window.gtag) return;
  // El admin es privado: no se mide
  if (path.startsWith("/admin")) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

// Eventos de conversión: newsletter_subscribe, booking_created, contact_sent,
// assistant_voice_start, outbound_social_click
export function trackEvent(name, params = {}) {
  // GA4 (si está configurado)
  if (GA_ID && window.gtag) window.gtag("event", name, params);
  // Analítica propia (siempre) — alimenta el panel /admin/stats
  trackInternal({ type: "event", event: name, meta: params, path: window.location.pathname });
}

// ─── Analítica first-party (sin cookies, sin terceros) ───
// Envía un beacon a /api/track. Funciona sin GA4: es la fuente del panel propio.
const API_URL = import.meta.env.VITE_API_URL || "";

// Banderas de visita, anónimas y sin PII:
//  - newSession: primera vista de esta pestaña (sessionStorage, efímero)
//  - newVisitor: primera vista de HOY de este navegador (localStorage guarda
//    solo la fecha, no un ID rastreable) → permite contar visitantes únicos
//    por día sin cookies ni fingerprinting.
function getVisitFlags() {
  let newSession = false;
  let newVisitor = false;
  try {
    if (!sessionStorage.getItem("cb_session")) {
      sessionStorage.setItem("cb_session", "1");
      newSession = true;
    }
    const today = new Date().toISOString().slice(0, 10);
    if (localStorage.getItem("cb_seen_day") !== today) {
      localStorage.setItem("cb_seen_day", today);
      newVisitor = true;
    }
  } catch {
    /* storage bloqueado (modo privado) — se pierde la dedup, no rompe nada */
  }
  return { newSession, newVisitor };
}

export function trackInternal(payload) {
  if (typeof window === "undefined") return;
  const path = payload.path || window.location.pathname;
  if (path.startsWith("/admin")) return; // el admin no se mide a sí mismo
  const body = JSON.stringify({
    referrer: document.referrer || "",
    ...payload,
    path,
  });
  try {
    // sendBeacon no bloquea la navegación ni la descarga de la página
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API_URL}/api/track`, new Blob([body], { type: "application/json" }));
    } else {
      fetch(`${API_URL}/api/track`, { method: "POST", body, headers: { "Content-Type": "application/json" }, keepalive: true });
    }
  } catch {
    /* la analítica nunca rompe la página */
  }
}

export function trackPageviewInternal(path) {
  const { newSession, newVisitor } = getVisitFlags();
  trackInternal({ type: "pageview", path, newSession, newVisitor });
}
